import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import './calendar.css';
import { isMobile } from "react-device-detect";

export default function EventCalendar({eventsData}) {

  const status_colors = {
    'default':'goldenrod'
  }

  const [events, setEvents] = useState([]);

  const parse_date=(datestr)=>{
    const [d,m,y] = datestr.split("/").map(Number);
    return new Date(y,m-1,d).toISOString();
  }

  useEffect(()=>{
    let _events = [];
    eventsData.forEach(e=>{
      let _status = 'default';
      if(!!e.order)
        _status = status_colors[_status];
      let _phone = "";
      if(e.client.phone && e.client.phone!=='')
        _phone = '('+e.client.phone+')';
      _events.push({title:e.client.label_name+_phone,
        start:parse_date(e.date),
        backgroundColor:status_colors[_status],
        textColor:'black',
        display:'block',
        className:'calendar-event'
      });})
    setEvents([..._events]);
  },[eventsData])

  const handleDateClick = (info) => {

  };

  let right_bts = "today,dayGridWeek,dayGridMonth"
  if(isMobile)
    right_bts = "dayGridWeek,dayGridMonth"


  return (
    <div className="p-4 max-w-4xl mx-auto">
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="dayGridWeek"
        selectable={true}
        editable={true}
        events={events}
        dateClick={handleDateClick}
        event
        eventTimeFormat={false}
        displayEventTime={false}
        buttonText={{
        today: "Aujourd'hui", // 👈 changes the Today button text
        month: 'Mois',
        week: 'Semaine',
        day: 'Jour',
        }}
        headerToolbar={{
          left: "prev,next",
          center: "title",
          right: right_bts//"dayGridMonth,timeGridWeek,timeGridDay",
        }}
      />
    </div>
  );
}